import { model as playerModel } from '$/player'
import { useUnit } from 'effector-react'
import { useCallback } from 'react'

export const useAnalytics = ({
  sourceUrl,
  contentId,
  contentType,
  contentTitle,
  contentProgram,
  contentOpenFrom,
}: {
  sourceUrl: string
  contentId: string
  contentType: string
  contentTitle?: string
  contentProgram?: string
  contentOpenFrom?: string
}) => {
  const analyticsDataStartEvent = useUnit(playerModel.play)
  const sendAnalyticsDataStartEventCallback = useCallback(
    (data: {
      audioLanguage: string
      textLanguage: string
      position: string
      duration: string
    }) => {
      if (!sourceUrl) return
      const { audioLanguage, textLanguage, position, duration } = data || {}

      analyticsDataStartEvent({
        contentId: String(contentId),
        contentUrl: sourceUrl,
        contentType,
        audioLanguage: audioLanguage || '',
        textLanguage: textLanguage || '',
        startedTime: position || '0',
        duration: duration || '0',
      })
    },
    [sourceUrl, contentId, contentType, analyticsDataStartEvent]
  )

  const analyticsDataStopPauseEvent = useUnit(playerModel.stop)
  const sendAnalyticsDataStopEventCallback = useCallback(
    (data: {
      audioLanguage: string
      textLanguage: string
      position: string
      duration: string
    }) => {
      if (!sourceUrl) return

      const { audioLanguage, textLanguage, position, duration } = data || {}

      analyticsDataStopPauseEvent({
        contentId: String(contentId),
        contentUrl: sourceUrl,
        contentType,
        audioLanguage: audioLanguage || '',
        textLanguage: textLanguage || '',
        startedTime: position || '0',
        duration: duration || '0',
      })
    },
    [sourceUrl, contentId, contentType, analyticsDataStopPauseEvent]
  )

  const analyticsDataWatchingContent = useUnit(playerModel.watchingContent)

  const sendAnalyticsContentWatchingCallback = useCallback(
    ({
      contentErrorCode,
      contentIsSuccessShow,
    }: {
      contentIsSuccessShow?: boolean
      contentErrorCode?: string
    }) => {
      analyticsDataWatchingContent({
        contentId: String(contentId),
        contentUrl: sourceUrl,
        contentType,
        contentTitle,
        contentProgramm: contentProgram,
        contentOpenFrom,
        contentErrorCode: contentErrorCode,
        contentIsSuccessShow: String(contentIsSuccessShow),
      })
    },
    [
      analyticsDataWatchingContent,
      contentId,
      sourceUrl,
      contentType,
      contentTitle,
      contentProgram,
      contentOpenFrom,
    ]
  )

  return {
    sendAnalyticsDataStartEventCallback,
    sendAnalyticsDataStopEventCallback,
    sendAnalyticsContentWatchingCallback,
  }
}
